// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__30Keh","imageUploader":"EGiftCard_imageUploader__3Hcev"};